const $ = window.$
import {registerReducer} from 'js/studios/shared/redux/utils'

const DEFAULT_PROJECT_CREATION_DATA = {
  sourceCategory: null,
  splashImage: null,
  category: null,
  budgetMin: "",
  budgetMax: "",
  budgetSkip: false,
  details: "",
  recipient: "",
  intent: "",
  significantOtherName: "",
  significantOtherNameSkip: false,
  centerStoneTypes: [],
  centerStoneSkip: false,
  designVisionSources: [],
  designVisionSkip: false,
  timeline: "",
  deliveryDate: null,
  categoryTop: "",
  categorySecondary: "",
  referringLeadPath: null,
  source: '',
  hidden_useragent: window.navigator.userAgent,
}

function projectCreationData(state=DEFAULT_PROJECT_CREATION_DATA, action){
  const newState = $.extend(true, {}, DEFAULT_PROJECT_CREATION_DATA, state)
  switch (action.type){
    case "UPDATE_PROJECT_CREATION_FIELD":
      newState[action.field] = action.value
      return newState
    case "PROJECT_CREATION_ADD_CENTER_STONE_TYPE":
      if (newState.centerStoneTypes.indexOf(action.value) === -1){
        newState.centerStoneTypes.push(action.value)
      }
      return newState
    case "PROJECT_CREATION_REMOVE_CENTER_STONE_TYPE":
      newState.centerStoneTypes = newState.centerStoneTypes.filter(centerStoneType => centerStoneType !== action.value)
      return newState
    case "PROJECT_CREATION_ADD_DESIGN_VISION_TYPE":
      if (newState.designVisionSources.indexOf(action.value) === -1){
        newState.designVisionSources.push(action.value)
      }
      return newState
    case "PROJECT_CREATION_UPDATE_TO_GENERIC_FLOW":
      newState.sourceCategory = null
      return newState
    case "PROJECT_CREATION_REMOVE_DESIGN_VISION_TYPE":
      newState.designVisionSources = newState.designVisionSources.filter(designVisionType => designVisionType !== action.value)
      return newState
    default:
      return newState
  }
}


const DEFAULT_PROJECT_CREATION = {
  flow: "engagement",
  frame: 0,
  preventionFrame: null,
}

function projectCreation(state=DEFAULT_PROJECT_CREATION, action){
  let newState = $.extend(true, {}, DEFAULT_PROJECT_CREATION, state)
  switch(action.type){
    // case "UPDATE_PROJECT_CREATION_FIELD":
    //   newState[action.field] = action.value
    //   return newState
    case "PROJECT_CREATION_NEXT_FRAME":
      newState.frame++
      return newState
    case "PROJECT_CREATION_PREVIOUS_FRAME":
      newState.frame--
      return newState
    case "PROJECT_CREATION_GO_TO_PREVENTION_FRAME":
      newState.preventionFrame = action.frame
      return newState
    case "PROJECT_CREATION_UPDATE_TO_GENERIC_FLOW":
      newState.flow = 'generic'
      return newState
    default:
      return newState
  }
}

registerReducer(projectCreation, 'projectCreation')
registerReducer(projectCreationData, 'projectCreationData')
